/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';

import Navbar from '../components/NavbarComponent';
import Footer from '../components/FooterComponent';
import FeedbackFormInputComponent from '../components/FeedbackFormInputComponent';
import { isMobile } from 'react-device-detect';
import { BACKEND_ENDPOINT } from '../../shared/config';

import css from '../styles/contact-us.scss';

const contactFields = [
  {
    label: 'First Name',
    name: 'firstName',
    type: 'SHORT',
    placeholder: 'John',
    error: '',
  },
  {
    label: 'Last Name',
    name: 'lastName',
    type: 'SHORT',
    placeholder: 'Doe',
    error: '',
  },
  {
    label: 'Email',
    name: 'email',
    type: 'EMAIL',
    placeholder: 'johndoe@gmail.com',
    error: 'Format email correctly. Ex: \'example@gmail.com\' ',
  },
  {
    label: 'Phone Number',
    name: 'phone',
    type: 'PHONE',
    placeholder: '(123) 456-7890',
    error: 'Format phone number correctly. Ex: \'(xxx) xxx-xxxx\'',
  },
  {
    label: 'Message*',
    name: 'message',
    type: 'LONG',
    placeholder: 'Write your message...',
    error: 'Required',
  },
];

class ContactPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitted: false,
      submitError: false,
      feedback: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        message: '',
      },
      valid: {
        firstName: true,
        lastName: true,
        email: true,
        phone: true,
        message: false,
      },
    };
  }

  onChange = (name, event) => {
    const { feedback } = this.state;
    this.setState({ feedback: { ...feedback, [name]: event.target.value } });
  };

  checkError = (name, isValid) => {
    const { valid } = this.state;
    this.setState({ valid: { ...valid, [name]: isValid } });
  }

  formatBody = (feedback) => {
    const { firstName, lastName, email, phone, ...updatedFeedback } = feedback;
    const fullName = (firstName === '' && lastName === '') ? 'N/A' : `${feedback.firstName} ${feedback.lastName}`;
    const finalEmail = email === '' ? 'N/A' : email;
    const finalPhone = phone === '' ? 'N/A' : phone;
    const finalFeedback = { ...updatedFeedback, name: fullName, email: finalEmail, phone: finalPhone };
    return finalFeedback;
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    const { feedback } = this.state;
    const finalFeedback = this.formatBody(feedback);
    console.log(finalFeedback);
    const requestOpts = {
      method: 'POST',
      dataType: 'JSON',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
      body: JSON.stringify(finalFeedback),
    };

    await fetch(
      `${BACKEND_ENDPOINT}/api/feedbackform`,
      requestOpts,
    )
      .then(res => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ submitted: true, submitError: false });
        },
        (error) => {
          console.log(error);
          this.setState({ submitted: true, submitError: true });
        },
      );
  }

  render() {
    const { submitted, submitError, valid } = this.state;
    if(!isMobile){
      return (
        <div>
          <div className={css.container}>
            <Navbar noShadow={false} />
            <div className={css.body}>
              <div className={css.sidebar}>
                <div className={css.sidebarContent}>
                  <div className={css.sidebarTitle}>Contact Us</div>
                  <br />
                  <div className={css.sidebarBody}>
                      Submit this form to contact the team.
                      To add a voice, please visit the {" "}
                    <a href="/add-your-voice"> add your voice page.</a>
                  </div>
                </div>
              </div>
              <form className={css.formBody} onSubmit={this.handleSubmit}>
                {submitted ? (
                  submitError ? (
                    <div className={css.postSubmit}>
                          Oops! There was an error on our end. Try refreshing and submitting again.
                    </div>
                  ) : (<div className={css.postSubmit}> Thanks for submitting! We'll get back to you soon!</div>)
                )
                  : (
                    <div className={css.formContainer}>
                      {contactFields.map(field => (
                        <FeedbackFormInputComponent
                          label={field.label}
                          type={field.type}
                          name={field.name}
                          value=""
                          placeholder={field.placeholder}
                          onChange={this.onChange}
                          checkError={this.checkError}
                          error={field.error}
                        />
                      ))}
                      <button type="submit" className={css.submitButton} disabled={!Object.values(valid).every(val => val)}>
                          Submit
                      </button>
                    </div>
                  )}
              </form>
            </div>
            <Footer mobile={false} admin={false} />
          </div>
        </div>
      );
    }
  else{
    return (
      <div className={css.mobileContainer}>
        <div><Navbar noShadow={false} /></div>
        <div className={css.mobileBody}>

            <div className={css.mobileHeader}>Contact Us</div>
            <div className={css.mobileSubtitle}>
                Submit this form to contact the team.{"\n"}
                To add a voice, please visit the
              <a  href="/add-your-voice"> add your voice page.</a>
            </div>

            <form className={css.mobileFormBody} onSubmit={this.handleSubmit}>
                {submitted ? (
                  submitError ? (
                    <div className={css.mobilePostSubmit}>
                          Oops! There was an error on our end. Try refreshing and submitting again.
                    </div>
                  ) : (<div className={css.mobilePostSubmit}> Thanks for submitting! We'll get back to you soon!</div>)
                )
                  : (
                    <div className={css.mobileFormContainer}>
                      <div className={css.mobileFormContent}>
                        <div>
                        {contactFields.map(field => <div className={css.mobileInputPadding}>
                          <FeedbackFormInputComponent
                            label={field.label}
                            type={field.type}
                            name={field.name}
                            value=""
                            placeholder={field.placeholder}
                            onChange={this.onChange}
                            checkError={this.checkError}
                            error={field.error}/>
                            </div>)}
                        </div>
                        <div>
                        <button type="submit" className={css.mobileSubmitButton} disabled={!Object.values(valid).every(val => val)}>
                            Submit
                        </button>
                        </div>
                      </div>
                    </div>
                  )}
              </form>
        </div>
      </div>
    );
  }
  }
}

export default ContactPage;
